import { Link } from "react-router-dom";
import { uniquePieceData } from "../types/uniquepiece";

export default function UniquePiece() {
  return (
    <section className="max-w-5xl mx-auto px-4 py-12 space-y-12">
      <h1 className="text-4xl font-bold mb-8">Pièces uniques</h1>

      <div className="grid gap-10 md:grid-cols-2">
        {uniquePieceData.map((item: any) => (
          <Link
            key={item.slug}
            to={`/uniquepiece/${item.slug}`}
            className="group block"
          >
            <div className="w-full aspect-[4/3] overflow-hidden rounded-lg">
              <img
                src={item.mainImage}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            <h2 className="mt-4 text-xl font-bold">{item.title}</h2>
            {item.intro && (
              <p className="text-sm text-gray-500 font-semibold mt-1 line-clamp-3">
                {item.intro}
              </p>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
}
